import { apiService } from '@/utils/api/index';

export default {
  /*  
    GET
  */
  getDirectoryId() {
    return apiService.get('/directory/details/get_pk/');
  },

  getDirectoryInfo(id) {
    return apiService.tabGet(`/directory_vendor/detail/${id}/`);
  },

  getPartners(id, page) {
    return apiService.get(`/directory_vendor/entries/${id}?page=${page}`);
  },

  getPartner(id, slug) {
    return apiService.get(`/directory_vendor/entry/detail/${id}/${slug}/`);
  },

  getIntegrationPartners(id) {
    return apiService.get(`/directory_vendor/integrations/list/${id}/`);
  },

  getIntegrationPartner(id, slug) {
    return apiService.get(
      `/directory_vendor/integrations/detail/${id}/${slug}/`
    );
  },

  getCategories(id) {
    return apiService.get(`/directory_vendor/categories/list/${id}/`);
  },

  /*
    POST
  */
  createMatchmakingRequest(id, data) {
    return apiService.post(`/directory_vendor/matchmaking/${id}/`, data);
  },

  createContactRequest(id, data) {
    return apiService.post(`/directory_vendor/entry/contact/${id}/`, data);
  },

  createReview(id, data) {
    return apiService.post(`/directory_vendor/entry/review-add/${id}/`, data);
  },
};
